@if (!dialogService.areAllDialogsHidden()) {
  <div
    class="promotional-dialog__container fixed bottom-0 m-3 left-0 z-50 flex flex-col items-start justify-start w-[300px]"
  >
    @for (dialog of dialogs$ | async; track $index) {
      @if (dialog.isVisible) {
        <div
          class="promotional-dialog__item"
          animate.leave="promotional-dialog__item--leave"
        >
          <div
            [ngClass]="{
              'theme-bg-primary': dialog.severity === 'info',
              'theme-bg-error': dialog.severity === 'error',
              'theme-bg-warning': dialog.severity === 'warning',
              'theme-bg-success': dialog.severity === 'success',
              'gray-theme-bg-1': dialog.severity === 'notification',
            }"
            class="relative w-full shadow text-center p-5 rounded-lg"
            style="margin-bottom: 1rem"
            (click)="$event.stopPropagation()"
            (keyup)="(null)"
          >
            <button
              class="absolute top-2 right-2 bg-transparent border-none text-white text-[20px] cursor-pointer"
              (click)="closeDialog(dialog.storageKey)"
            >
              ✕
            </button>
            <div class="p-2 rounded-md text-left">
              <h3 class="text-[16px] font-bold mb-2 text-white">
                {{ dialog.title }}
              </h3>

              <div class="flex items-center justify-between">
                <div class="mr-2">
                  <p
                    class="text-[14px] text-white leading-[1.4]"
                    [ngStyle]="{ width: '230px' }"
                    [innerHTML]="dialog.description"
                  ></p>
                </div>
                <div>
                  @if (dialog.hasDownloadButton) {
                    <button
                      (click)="download(dialog)"
                      mat-icon-button
                      class="material-icons-outlined !text-white"
                    >
                      cloud_download
                    </button>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    }
  </div>
}
